/**
 * Utilidades de fecha para el control de vencimientos de farmacia.
 * Se trabaja siempre con fechas locales (YYYY-MM-DD) para evitar
 * desfases de zona horaria al comparar con la fecha actual del sistema.
 */

export function parseLocalDate(value?: string | null): Date | null {
  if (!value) return null;
  const base = String(value).split('T')[0];
  const parts = base.split('-');
  if (parts.length !== 3) return null;
  const year = Number(parts[0]);
  const month = Number(parts[1]);
  const day = Number(parts[2]);
  if (!year || !month || !day) return null;
  const date = new Date(year, month - 1, day);
  if (Number.isNaN(date.getTime())) return null;
  return date;
}

export function formatFecha(value?: string | null): string {
  const date = parseLocalDate(value);
  if (!date) return '—';
  return date.toLocaleDateString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export type ExpiryStatus = 'none' | 'ok' | 'soon' | 'expired';

/**
 * 'expired' → ya venció
 * 'soon'    → vence en 3 meses o menos
 * 'ok'      → vence en más de 3 meses
 * 'none'    → sin fecha registrada
 */
export function getExpiryStatus(value?: string | null): ExpiryStatus {
  const date = parseLocalDate(value);
  if (!date) return 'none';

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  if (date.getTime() < today.getTime()) return 'expired';

  const limit = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  limit.setMonth(limit.getMonth() + 3);
  if (date.getTime() <= limit.getTime()) return 'soon';

  return 'ok';
}